module.exports = __webpack_public_path__ + "static/img/flag-UK.f0cb3053.png";